// AssigneeSelector.js
// Dropdown component for selecting who a todo is assigned to

import React from 'react';

function AssigneeSelector({ id, value, onChange, familyData, currentUserId, isPremium }) {
  // Get the list of family members from familyData
  // memberNames is an object like: { "uid1": "John", "uid2": "Jane" }
  const memberNames = familyData?.memberNames || {};

  // Convert to array of [userId, firstName] pairs
  // Sort so current user appears first
  const members = Object.entries(memberNames).sort((a, b) => {
    // Current user first
    if (a[0] === currentUserId) return -1;
    if (b[0] === currentUserId) return 1;
    // Then alphabetically by name
    return a[1].localeCompare(b[1]);
  });

  return (
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {/* Unassigned option */}
      <option value="">Unassigned</option>

      {/* Family members */}
      {members.map(([userId, firstName]) => (
        <option key={userId} value={userId}>
          {firstName}
          {userId === currentUserId ? ' (me)' : ''}
        </option>
      ))}

      {/* AI Assistant option */}
      <option value="ai">
        🤖 AI Assistant{!isPremium ? ' ✨' : ''}
      </option>
    </select>
  );
}

export default AssigneeSelector;
